/*! @azure/msal-common v15.2.0 2025-02-18 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Authority types supported by MSAL.
 */
const AuthorityType = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3,
};

export { AuthorityType };
//# sourceMappingURL=AuthorityType.mjs.map
